// extracted by mini-css-extract-plugin
export default {"description":"W4lrkUfJ4EoUr_ZhoVxX","descriptionTitle":"XhpT1mtRtmMPJEdxlRI_"};